class Filter {
    /**
     * Filters used for sorting and querying data
     * @param {{
     *   query: string|null,
     *   sort: Sort|null
     *   page: number
     *   scope: number?,
     *   pageSize: number?,
     *   filters: object?,
     * }} obj
     */
    // @ts-ignore
    constructor(obj = {}) {
        this.query = obj.query
        this.sort = obj.sort;
        this.scope = obj.scope;
        this.page = obj.page ?? 0;
        this.pageSize = obj.pageSize ?? 30;
        this.filters = obj.filters;
    }

    toString() {
        return JSON.stringify(this);
    }
}

class Sort {
    constructor(field, direction) {
        if (!field) throw 'Field is required for sort!';
        this.field = field;
        this.direction = direction;
    }
}

export {
    Filter,
    Sort
}